import { Conversation } from './types/Conversation';
import { MakeCall } from './createMakeCall';

export interface Query {
  expand: string;
  translateToLanguage?: string;
}

const getConversation =
  (makeCall: MakeCall) => (conversationId: number | string, query?: Query) =>
    makeCall<Conversation>('GET', `/api/v2/conversation/${conversationId}`, {
      query,
    });

export { getConversation };
